import Vue from "vue";
import VueRouter from "vue-router";

import index from "../views/index.vue";
import classification from "../views/classification.vue";
import list from "../views/list.vue";

import travel from "./modules/travel";
import travelVideo from "./modules/travelVideo";
import travelPhoto from "./modules/travelPhoto";
import travelGroup from "./modules/travelGroup";
import travelAdmissionFee from "./modules/travelAdmissionFee";
import travelHotel from "./modules/travelHotel";

import edit from "./modules/edit";
import editBeautiful from "./modules/editBeautiful";
import editAdd from "./modules/editAdd";
import editAI from "./modules/editAI";
import editToning from "./modules/editToning";
import editPicture from "./modules/editPicture";
import editSlimming from "./modules/editSlimming";
import editVideoClips from "./modules/editVideoClips";
import editVideoEditing from "./modules/editVideoEditing";

import smartLife from "./modules/smartLife";
import smartLifeMonitor from "./modules/smartLifeMonitor";
import smartLifeLock from "./modules/smartLifeLock";
import smartLifeCreate from "./modules/smartLifeCreate";
import smartLifePartner from "./modules/smartLifePartner";
import smartLifeSmartHome from "./modules/smartLifeSmartHome";
import smartLifeAIGeneratedImages from "./modules/smartLifeAIGeneratedImages";
import smartLifeAIGeneratedVideos from "./modules/smartLifeAIGeneratedVideos";
import smartLifeAIMusic from "./modules/smartLifeAIMusic";
import smartLifeAIPhotography from "./modules/smartLifeAIPhotography";
import smartLifeAIImageEditing from "./modules/smartLifeAIImageEditing";
import smartLifeAIDigitalHuman from "./modules/smartLifeAIDigitalHuman";
import smartLifeAIWriting from "./modules/smartLifeAIWriting";
import smartLifeAIHealth from "./modules/smartLifeAIHealth";

import entertainment from "./modules/entertainment";
import entertainmentSong from "./modules/entertainmentSong";
import entertainmentLiveBroadcast from "./modules/entertainmentLiveBroadcast";
import entertainmentSee from "./modules/entertainmentSee";
import entertainmentFollowWorks from "./modules/entertainmentFollowWorks";
import entertainmentFilm from "./modules/entertainmentFilm";
import entertainmentPublishWorks from "./modules/entertainmentPublishWorks";
import entertainmentHear from "./modules/entertainmentHear";

import study from "./modules/study";
import studyOldStudy from "./modules/studyOldStudy";
import studyForum from "./modules/studyForum";
import studyCourse from "./modules/studyCourse";
import studyBooks from "./modules/studyBooks";
import studyLearnShow from "./modules/studyLearnShow";
import studyHeFei from "./modules/studyHeFei";
import studyActivityParticipation from "./modules/studyActivityParticipation";
import studyCourseLearning from "./modules/studyCourseLearning";
import studyLiveStreaming from "./modules/studyLiveStreaming";
import studyYuetingResources from "./modules/studyYuetingResources";
import studyAnHui from "./modules/studyAnHui";
import studyCountry from "./modules/studyCountry";

import end from "./modules/end";

import over from "@/router/modules/over";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
  },
  {
    path: "/classification",
    name: "classification",
    component: classification,
  },
  {
    path: "/list",
    name: "list",
    component: list,
  },
  // 结尾模块
  end,

  // 旅行与拍摄模块
  travel,
  travelVideo, // 视频拍摄模块
  travelPhoto, // 照片拍摄模块
  travelGroup, // 手机报团模块
  travelAdmissionFee, // 手机买门票模块
  travelHotel, // 手机订酒店模块

  // 修图剪辑模块
  edit,
  editBeautiful, // 人物美颜模块
  editAdd, // 添加文字
  editAI, // AI
  editToning, // 景物调色模块
  editPicture, // 快速拼图模块
  editSlimming, // 瘦身美体模块
  editVideoClips, // 视频初剪模块
  editVideoEditing, // 视频精剪模块

  // 智能生活模块
  smartLife,
  smartLifeMonitor, // 监控模块
  smartLifeLock, // 智能锁模块
  smartLifeCreate, // AI艺术创作模块
  smartLifePartner, // 智能合伙人模块
  smartLifeSmartHome, // 智能家居模块
  smartLifeAIGeneratedImages, // AI生图模块
  smartLifeAIGeneratedVideos, // AI生视频模块
  smartLifeAIDigitalHuman, // AI数字人模块
  smartLifeAIImageEditing, // AI修图模块
  smartLifeAIMusic, // AI音乐模块
  smartLifeAIPhotography, // AI写真模块
  smartLifeAIWriting, // AI写作模块
  smartLifeAIHealth, // AI健康模块

  // 休闲娱乐模块
  entertainment,
  entertainmentSong, // 全民K歌模块
  entertainmentLiveBroadcast, // 直播模块
  entertainmentSee, // 手机看剧模块
  entertainmentFollowWorks, // 关注作品模块
  entertainmentFilm, // 电影模块
  entertainmentPublishWorks, // 发布作品模块
  entertainmentHear, // 听书模块

  // 老有所学模块
  study,
  studyOldStudy, // 老有所学模块
  studyForum, // 名师讲坛模块
  studyCourse, // 视频课程模块
  studyBooks, // 数字图书模块,
  studyLearnShow, // 我学我秀模块
  studyHeFei, // 合肥模块
  studyActivityParticipation, // 参与活动模块
  studyCourseLearning, // 课程学习模块
  studyLiveStreaming, // 直播模块
  studyYuetingResources, // 悦听资源模块
  studyAnHui, // 安徽模块
  studyCountry, // 国家老年大学模块

  // 结尾模块
  end,

  // 结束页面
  over,
];

const router = new VueRouter({
  // mode: "history",
  routes,
});

// // 解决编程式路由往同一地址跳转时会报错的情况
// const originalPush = VueRouter.prototype.push;
// const originalReplace = VueRouter.prototype.replace;
//
// // push
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => err);
// };
//
// //replace
// VueRouter.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalReplace.call(this, location, onResolve, onReject);
//   return originalReplace.call(this, location).catch(err => err);
// };

export default router;
